'use client';

import { useEffect, useRef } from 'react';
import { captureAnalyticsEvent } from '@/lib/analytics/posthog';
import { useUser } from '@/store/hooks';

export default function LandingPageAnalytics() {
  const { user, isAuthenticated } = useUser();
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (hasTrackedRef.current) return;

    captureAnalyticsEvent('site_visitor', {
      page: 'home',
      path: '/',
      isAuthenticated,
    });
    hasTrackedRef.current = true;
  }, [isAuthenticated, user?.id]);

  return null;
}
